import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Container } from '../models/container.model';

@Injectable({
  providedIn: 'root',
})
export class ContainerService {
  private apiUrl = environment.apiUrl + environment.containerPath;

  constructor(private http: HttpClient) {}

  getContainers(): Observable<Container[]> {
    return this.http.get<Container[]>(this.apiUrl);
  }

  getContainerById(id: number): Observable<Container> {
    return this.http.get<Container>(`${this.apiUrl}/${id}`);
  }

  createContainer(container: Container): Observable<Container> {
    return this.http.post<Container>(this.apiUrl, container);
  }

  updateContainer(id: number, container: Container): Observable<Container> {
    return this.http.put<Container>(`${this.apiUrl}/${id}`, container);
  }

  deleteContainer(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  disabledContainer(container: Container): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}${environment.disabledPath}/${container.id}`,
      container,
    );
  }
}
